module.exports = __webpack_public_path__ + "img/man-avatar.9adad164.png";